module.exports = __webpack_public_path__ + "img/caseimeiopposcan.134fe404.png";